import { commandCounsellorGroupComponent } from './command-counsellor-group.component';

export const commandCounsellorGroup = angular
	.module('components.command-counsellor-group.commandCounsellorGroup', [])
	.component('commandCounsellorGroup', commandCounsellorGroupComponent)
	.config(($stateProvider) => {
		'ngInject';

		$stateProvider.state('commandCounsellorGroup', {
				parent: 'app',
				url: '/home/command-counsellor-group/details',
				breadcrumbName: 'Group view',
				parentState: 'home',
				component: 'commandCounsellorGroup',
				resolve: {
					details(CommandCounsellorGroupService) {
						"ngInject";
						return CommandCounsellorGroupService.getGroupByTm();
					},
				}
			});
	})
	.name;	


// WEBPACK FOOTER //
// ./src/app/components/command-counsellor-group/command-counsellor-group-details/command-counsellor-group.module.js